import { getLandingVariant } from '@/utils/landing-variant'
import { CubeSanteRegisterPage } from './CubeSanteRegisterPage'
import { DefaultRegisterPage } from './DefaultRegisterPage'
import { ZoomDocNYRegisterPage } from './ZoomDocNYRegisterPage'

export function RegisterPage() {
  const variant = getLandingVariant()

  switch (variant) {
    case 'zoomdocny':
      return <ZoomDocNYRegisterPage />
    case 'cubesante':
      return <CubeSanteRegisterPage />
    default:
      return <DefaultRegisterPage />
  }
}
